import { render } from "./NewSupportTicket.vue?vue&type=template&id=45e9c190&scoped=true"
import script from "./NewSupportTicket.vue?vue&type=script&lang=js"
export * from "./NewSupportTicket.vue?vue&type=script&lang=js"

import "./NewSupportTicket.vue?vue&type=style&index=0&id=45e9c190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e9c190"]])

export default __exports__